// =============================================================================
// features/sales/campaigns/wizard/useWizardStepUrl.ts — Etapa atual + id do
// rascunho refletidos na querystring (`?draft=<id>&step=<n>`), extraído de
// WizardContent.tsx para manter o orquestrador abaixo de 200 linhas (norma
// anti-padrão do DS). É a peça que torna o rascunho retomável por reload ou
// link direto (DoD do slot).
// =============================================================================

import * as React from 'react';
import { useSearchParams } from 'react-router-dom';

import { WIZARD_STEP_IDS } from './types';
import type { WizardStepId } from './types';

function parseStep(raw: string | null): WizardStepId {
  const n = Number(raw);
  return WIZARD_STEP_IDS.includes(n as WizardStepId) ? (n as WizardStepId) : 1;
}

export interface UseWizardStepUrlResult {
  campaignId: string | null;
  setCampaignId: (id: string | null) => void;
  step: WizardStepId;
  furthestReached: WizardStepId;
  goToStep: (next: WizardStepId, id?: string | null) => void;
  resetToStart: () => void;
}

export function useWizardStepUrl(): UseWizardStepUrlResult {
  const [searchParams, setSearchParams] = useSearchParams();

  const [campaignId, setCampaignIdState] = React.useState<string | null>(searchParams.get('draft'));
  const [step, setStep] = React.useState<WizardStepId>(parseStep(searchParams.get('step')));
  const [furthestReached, setFurthestReached] = React.useState<WizardStepId>(step);

  function goToStep(next: WizardStepId, id: string | null = campaignId): void {
    setStep(next);
    setFurthestReached((prev) => (next > prev ? next : prev));
    const params: Record<string, string> = { step: String(next) };
    if (id) params.draft = id;
    setSearchParams(params, { replace: true });
  }

  function setCampaignId(id: string | null): void {
    setCampaignIdState(id);
  }

  function resetToStart(): void {
    setCampaignIdState(null);
    setStep(1);
    setFurthestReached(1);
    setSearchParams({}, { replace: true });
  }

  return { campaignId, setCampaignId, step, furthestReached, goToStep, resetToStart };
}
